<template>
	<div class="bg-white">
		<div class="px-2 py-4" :class="{'bg-blue-800 sticky top-0 z-10': showPhase, 'border-b': !showPhase, 'bg-purple-800': isForecast && showPhase}">
			<div class="flex items-center cursor-pointer" :class="{'text-black': !showPhase, 'text-white': showPhase}" @click="togglePhase">
				<chevron-component class="mr-1" :show="showPhase" :class="{'text-white': showPhase}"></chevron-component>
				<h3>
					Phase {{ phase.phase_detail.name}} <span class="text-xs font-normal text-blue-800">{{ phase.phase_detail.id }}</span>
				</h3>
			</div>
		</div>
		<div class="" v-show="showPhase">
			<div class="bg-white" v-if="(phase.ret_gen.length || phase.carports.length || phase.areas) && (isAdmin || role === 'Regional Manager' || role === 'Site Manager')">
				<div class="flex items-center justify-between p-4 pl-3 pr-2 bg-gray-300 cursor-pointer border-white" @click="toggleRetic" :class="{'sticky border-b top-0 z-10': showRetic, 'border-b': !showRetic}" style="top:57px" v-if="(isAdmin || role === 'Regional Manager')">
					<div class="flex items-center">
						<chevron-component class="mr-1" :show="showRetic"></chevron-component>
						<h4 :class="showRetic ? 'font-bold' : 'font-normal'">Reticulation</h4>						
					</div>
				</div>
				<div v-show="showRetic">
					<div class="flex flex-wrap" v-if="(isAdmin || role === 'Regional Manager')">
						<div class="group w-full relative text-sm" v-for="area in phase.areas" :key="area.area_detail.id">
							<div class="flex items-center justify-between pl-5 bg-gray-200" :class="isForecast ? 'p-3' : 'p-1'">
								<div class="flex-1 flex items-center justify-between">
									<h4 class="text-black font-bold">
										{{ area.area_detail.name }} <span class="text-xs font-normal text-gray-200">{{ area.area_detail.id }}</span>
										<span class="mx-2 rounded-full bg-red-400 text-white text-xs px-1 leading-none" v-if="area.area_detail.active === 2">review</span>
									</h4>
									<div class="flex items-center">
										<div class="flex items-center p-2 cursor-pointer bg-white rounded mr-2" :class="{'bg-red-200 text-red-700': !areaFileExists(area.area_detail.id)}"  v-if="notForecast" @click="showFileUploadModal(3, phase.phase_detail.name, area.area_detail.id, null, null)">
											<upload-icon class="w-4 h-4"></upload-icon>
											<span class="inline-block ml-2" >{{areaFileExists(area.area_detail.id) ? "Change" : "Upload"}}</span>
										</div>
										<div class="flex item-center justify-between">
											<datetime type="date" :input-class="dateInputClass(area.area_detail.id)" value-zone="local" v-if="notForecast" v-model="form.areaDate[area.area_detail.id]" placeholder="Delivery Date" id="start_datetime"></datetime>
										</div>
									</div>
								</div>
								<div class="w-20 flex-shrink-0 text-center text-blue-700">allocated</div>
								<div class="w-20 flex-shrink-0 text-center text-blue-700">used</div>
								<div class="w-20 flex-shrink-0 text-center text-blue-700 sm:block">forecast</div>
								<div class="w-24 sm:w-32 flex items-center justify-end">
									<!-- <action-button class="p-2" @button-clicked.stop="addArea(area.area_detail.name, area.area_detail.id)" v-if="(isAdmin || role === 'Regional Manager') && area.order_placed=='n' && notForecast && area.area_detail.active != 2">
										<edit-icon class="w-4 h-4"></edit-icon>
									</action-button>
									<span class="flex p-2 text-gray-600 cursor-pointer" v-if="notForecast && area.area_detail.active != 2" @click="showSpecialOrder(3, phase.phase_detail.name, area.area_detail.id, null, null)">
										<clipboard-icon class="w-4 h-4"></clipboard-icon>
									</span> -->
								</div>
							</div>
							<div class="sm:pl-6">
								<div class="flex items-center flex-wrap relative text-sm text-gray-800 pl-5 p-1 border-t first:border-t-0" v-for="product in area.area_products" :key="product.id">
									<div class="flex-1 flex items-center">
										<span class="flex-1">
											{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span>
											<template v-if="product.category_id != 4 ">
												- {{ product.feeds > 1 ? `${product.feeds} feeds` : `${product.feeds} feed` }} Estimated Price : R {{ product.price_estimated }}
											</template>
										</span>
									</div>
									<div class="sm:inline-block w-20 flex-shrink-0 text-center">{{ product.allocated }}</div>
									<div class="sm:inline-block w-20 flex-shrink-0 text-center">{{ product.used }}</div>
									<div class="inline-block w-20 flex-shrink-0 text-center">{{ product.forecasted - product.used }}</div>
									<div class="w-24 sm:w-32 text-right">
										<input class="w-20 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'cursor-not-allowed opacity-50': !canEditArea(area, product)}" type="text" @input="modifyAreaProductQty(product, $event, area.area_detail.id)" placeholder="qty" :disabled="!canEditArea(area, product)" v-if="(product.allocated - product.used) > 0">
										<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-else></check-circle-icon>
									</div>
									<div class="text-right w-full pt-1" v-if="addOrderComment[area.area_detail.id] && addOrderComment[area.area_detail.id].includes(product.id)">
										<textarea class="bg-white rounded border border-gray-200 w-full p-1" name="" id="" cols="30" rows="3" placeholder="comment" @input="modifyProductComment(product, $event, area.area_detail.id,'','Area')">
										</textarea>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="text-sm" v-if="phase.ret_gen.length">
						<div class="flex items-center justify-between pl-5 bg-blue-100" :class="isForecast ? 'p-3' : 'p-1'">
							<span class="flex-1 text-black font-bold">
								Reticulation general
							</span>
							<div class="w-20 flex-shrink-0 text-center text-blue-700" v-if="isForecast">allocated</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700">stock</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700 sm:block" v-if="isForecast">avail to forecast</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700 sm:block" v-else>forecast</div>
							<div class="w-24 flex-shrink-0 sm:w-32 px-1 flex items-center justify-end">
								<!-- <span class="flex p-2 text-blue-700 cursor-pointer" v-if="notForecast && isAdmin" @click="showSpecialOrder(4, phase.phase_detail.name, null, null, null)">
									<clipboard-icon class="w-4 h-4"></clipboard-icon>
								</span> -->
							</div>
						</div>
						
						<div class="mt-2 sm:pl-6">
							
							<div class="flex flex-wrap items-center relative pl-5 p-1 text-sm border-b" v-for="product in phase.ret_gen" :id="product.id" :key="product.id">
								<div class="flex-1">
									{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span>
								</div>
								<span class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated }}</span>
								<!-- <span class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</span> -->
								<span class="w-20 flex-shrink-0 text-center">{{ product.stock_qty > 0 ? product.forecast_received - product.forecast_ordered : 0 }}</span>
								<span class="sm:inline-block w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated - product.forecasted }}</span>
								<span class="sm:inline-block w-20 flex-shrink-0 text-center" v-else>{{ product.forecasted - product.used }}</span>
								<div class="w-24 flex-shrink-0 sm:w-32 text-right">
									<input v-if="canEditQty(product)" class="w-full text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'RetGen')" placeholder="qty">
									<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="(product.allocated - product.used) <= 0 && product.forecasted >0"></check-circle-icon>
									<template v-if="notForecast">
										<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used && product.used < product.allocated"></clock-icon>
										<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty <= 0"></alert-circle-icon>
									</template>
								</div>
								<div class="text-right w-full pt-1" v-if="addRetGenComment.indexOf(product.id)!=-1">
									<!-- <input-name="productId" :value="product.id"/> -->
									<textarea class="bg-white rounded border border-gray-200 w-full p-1" name="" id="" cols="30" rows="3" placeholder="comment" @input="modifyProductComment(product, $event, '',phase.phase_detail.id,'RetGen')"></textarea>
								</div>
							</div>
						</div>
					</div>
					<div class="text-sm" v-if="phase.carports.length">
						<div class="flex items-center justify-between pl-5 bg-blue-100" :class="isForecast ? 'p-3' : 'p-1'">
							<span class="w-full flex-1 text-black font-bold">
								Carports
							</span>
							<div class="w-20 flex-shrink-0 text-center text-blue-700" v-if="isForecast">allocated</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700">stock</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700 sm:block" v-if="isForecast">avail to forecast</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700 sm:block" v-else>forecast</div>
							<div class="w-24 flex-shrink-0 sm:w-32 px-1 flex items-center justify-end">
								<span class="p-2 text-blue-700 cursor-pointer" v-if="notForecast && isAdmin" @click="showSpecialOrder(10, phase.phase_detail.name, null, null, null)">
									<clipboard-icon class="w-4 h-4"></clipboard-icon>
								</span>
							</div>
						</div>
						<div class="mt-2 sm:pl-6">
							
							<div class="flex items-center relative pl-5 p-1 text-sm border-b" v-for="product in phase.carports" :id="product.id" :key="product.id">
								<div class="w-full flex-1">
									{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span>
								</div>
								<span class="w-20 text-center" v-if="isForecast">{{ product.allocated }}</span>
								<span class="w-20 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</span>
								<span class="sm:inline-block w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated - product.forecasted }}</span>
								<span class="sm:inline-block w-20 flex-shrink-0 text-center" v-else>{{ product.forecasted - product.used }}</span>
								<div class="w-24 sm:w-32 flex-shrink-0 text-right">
									<input v-if="(notForecast && (product.allocated - product.used) > 0 && product.stock_qty > 0 && product.pdt_status == 'in_stock') || (isForecast && (product.allocated - product.used) > 0)" class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'Carports')" placeholder="qty">
									<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="(product.allocated - product.used) <= 0 && product.forecasted > 0"></check-circle-icon>
									<template v-if="notForecast">
										<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used && product.used < product.allocated"></clock-icon>
										<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty == 0"></alert-circle-icon>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="border-t" v-if="phase.blocks">
				<order-block-component v-for="block in phase.blocks" @reload="$emit('reload')" :job="job" :block="block" :key="block.block_detail.id" :active-block="activeBlock" @update:activeblock="toggleBlock($event)"></order-block-component>
			</div>
		</div>
		<portal to="modals" v-if="addProduct" :order="1">
			<product-modal
				:show="addProduct"
				:cat-id="productCatId"
				:area-id="productAreaId"
				:exisiting-products="filteredProducts"
				:set-name="productSetName"
				@close="closeAddProduct"
				@save="saveProducts"
				>
			</product-modal>
		</portal>
		<portal to="modals" v-if="specialOrder.show" :order="1">
			<special-order-modal
				:show="specialOrder.show"
				:job="job"
				:special-order="specialOrder"
				@close="closeSpecialOrder"
				@save="saveSpecialOrder"
				@reload="$emit('reload')"
				>
			</special-order-modal>
		</portal>
		<portal to="modals" v-if="fileUpload.show" :order="1">
			<file-upload-modal
				:show="fileUpload.show"
				:job="job"
				:fileUpload="fileUpload"
				@close="closeFileUploadModal"
				@save="saveUploadedFile"
				@reload="$emit('reload')"
				>
			</file-upload-modal>
		</portal>
	</div>
</template>

<script>
import { UploadIcon } from 'vue-feather-icons';
import FileUploadModal from '../common/FileUploadModal.vue'
import SpecialOrderModal from '../common/SpecialOrderModal.vue'
import ProductModal from '@/components/common/ProductModal.vue'
import OrderBlockComponent from './OrderBlockComponent.vue'
import { Datetime } from 'vue-datetime';

export default {
	props: ['job', 'phase', 'activePhase'],
	name: 'PhaseOrder',

	data () {
		return {
			specialOrder: {
				show: false,
				catId: false,
				phase: false,
				area: false,
				block: false,
				unit: false,
			},
			fileUpload: {
				show: false,
				catId: false,
				phase: false,
				area: false,
				block: false,
				unit: false,
			},
			showPhase: this.activePhase || false,
			showRetic: false,
			addProduct: false,
			productSetName: false,
			productCatId: null,
			productAreaId: null,
			addOrderComment: {},
			addRetGenComment: [],
			role: this.$store.getters['auth/role'],
			activeBlock: null,
			form: {
				areaDate: [],
				areaQty: []
			}
		}
	},
	components: {
		UploadIcon,
		OrderBlockComponent,
		SpecialOrderModal,
		ProductModal,
		FileUploadModal,
    	Datetime
	},
	computed: {
		location: function(){
			return this.$route.name;
		},
		isForecast: function(){
			return this.location == 'Forecast Order'
		},
		notForecast: function(){
			return !this.isForecast;
		},
		filteredProducts: function () {
			if (!this.productCatId) {
				return []
			}
			if (this.getProductCategoryName === 'Reticulation') {
				var that = this
				let areas = this.$_.cloneDeep(this.phase.areas);
				return this.$_.reduce(areas, function (newObj, area, k) {
					if (area.area_detail.id === that.productAreaId) {
						newObj = area.area_products
					}
					return newObj
				}, {})
			}
			
			return []
		},
		getProductCategoryName: function () {
			return this.$store.getters.getProductCategoryNameById(this.productCatId)
		},
		isAdmin: function(){
			return this.role === 'Super Admin' || this.role === 'Administrator';
		},
		isManager: function(){
			return this.role === 'Regional Manager' || this.role === 'Site Manager';
		},
		areaFiles: function(){
			return this.$store.getters['order/getAreaFiles'];
		}
	},
	watch: {
		activePhase: function(newVal, oldVal){
			if(newVal !== this.phase.phase_detail.id){
				this.showPhase = false;
			}
		}
	},
	methods: {
		togglePhase: function(){
			this.showPhase = !this.showPhase;
			if(this.showPhase){
				this.$emit('update:activephase', this.phase.phase_detail.id);
			}else{
				this.$emit('update:activephase', null);				
			}
		},
		toggleRetic: function(){
			this.showRetic = !this.showRetic;
			this.activeBlock = null;
		},
		toggleBlock: function(newVal){
			this.activeBlock = newVal;
			this.showRetic = false;
		},
		canEditArea: function(area, product){
			if(this.notForecast){
				return (product.allocated - product.used) > 0 && area.area_detail.active != 2;
			}
			return (product.allocated - product.forecasted) > 0 && area.area_detail.active != 2
		},
		canEditQty: function(product){
			if(this.notForecast){
				return (product.allocated - product.used > 0)
					&& product.stock_qty > 0
						&& product.forecast_received - product.forecast_ordered > 0;
			}
			return (product.allocated - product.forecasted) > 0;
		},
		addArea: function (name = false, id = null) {
			console.log(name)
			console.log(id)
			this.productCatId = 3
			this.productAreaId = id
			this.addProduct = true
			this.productSetName = name || true
		},
		closeAddProduct: function () {
			this.addProduct = false
			this.productCatId = null
			this.productAreaId = null
			this.productSetName = false
			this.duplicateObject = null
		},
		areaFileExists: function(areaId){
			return this.areaFiles[areaId];
		},
		dateInputClass: function(areaId){
			let theClass = "w-32 mr-2 bg-white appearance-none rounded py-2 px-2 leading-tight focus:outline-none focus:shadow-outline";
			if(this.form.areaDate[areaId] == ''){
				theClass = "w-32 mr-2 bg-red-200 text-red-700 appearance-none rounded py-2 px-2 leading-tight focus:outline-none focus:shadow-outline placeholder-red-700";
			}			
			return theClass;
		},
		saveProducts: function (products, catId = false) {
			var endPoint = ''
			var requestMethod = 'post'
			var url = ''
			if (this.getProductCategoryName === 'Reticulation') {
				endPoint = 'areas'
				products.loc = 'order'
				requestMethod = 'post'
				if (products.areaId) {
					endPoint = `areas/${products.areaId}`
					requestMethod = 'patch'
					delete products.areaId
				}
			}

			url = `jobs/${this.phase.phase_detail.job_id}/phases/${this.phase.phase_detail.id}/${endPoint}`

			this.$http({
				method: requestMethod,
				url: url,
				data: (requestMethod === 'post' || requestMethod === 'put' || requestMethod === 'patch') ? products : {},
				params: requestMethod === 'get' ? products : {}
			})
				.then(response => {
					this.response = response.data
					this.closeAddProduct()
					this.$emit('reload')
				})
				.catch(err => {
					this.error = err
				})
				.finally(() => {
					this.loading = false
				})
		},
		ToggleRetcGen: function(){
			if(event.target.checked){
				this.$store.commit('order/addArea', {
					'phaseId': this.phase.phase_detail.id,
					'areaId': areaId
				});
			}else{
				this.$store.commit('order/removeArea',{
					'areaId': areaId,
					'phaseId': this.phase.phase_detail.id
				});
			}
		},
		showFileUploadModal: function(catId, phase, area, block, unit){
			this.fileUpload.show = true;
			this.fileUpload.catId = catId;
			this.fileUpload.phase = phase;
			this.fileUpload.area = area;
			this.fileUpload.block = block;
			this.fileUpload.unit = unit;
		},
		closeFileUploadModal: function(){
			this.fileUpload.show = false;
			this.fileUpload.phase = false;
			this.fileUpload.area = false;
			this.fileUpload.block = false;
			this.fileUpload.unit = false;
		},
		saveUploadedFile: function(){
			console.log('http');
		},
		showSpecialOrder: function(catId, phase, area, block, unit){
			this.specialOrder.show = true;
			this.specialOrder.catId = catId;
			this.specialOrder.phase = phase;
			this.specialOrder.area = area;
			this.specialOrder.block = block;
			this.specialOrder.unit = unit;
		},
		closeSpecialOrder: function(){
			this.specialOrder.show = false;
			this.specialOrder.phase = false;
			this.specialOrder.area = false;
			this.specialOrder.block = false;
			this.specialOrder.unit = false;
		},
		saveSpecialOrder: function(){
			console.log('http');
		},
		ToggleArea: function(areaId, event){
			if(event.target.checked){
				this.$store.commit('order/addArea', {
					'phaseId': this.phase.phase_detail.id,
					'areaId': areaId
				});
			}else{
				this.$store.commit('order/removeArea',{
					'areaId': areaId,
					'phaseId': this.phase.phase_detail.id
				});
			}
			// console.log(this.$store.getters['order/getOrder'])
		},
		modifyProductQty: function(product, event, type){
			if(type=='RetGen') {
				if(event.target.value){
					if((this.isForecast && event.target.value > (product.allocated - product.forecasted)) || (this.notForecast && event.target.value > (product.allocated - product.used))){
						if(!this.addRetGenComment.includes(product.id)){
							this.addRetGenComment.push(product.id);
						}
					}else{
						if(this.addRetGenComment.includes(product.id)){
							this.addRetGenComment.splice(this.addRetGenComment.indexOf(product.id),1);
						}
					}
				} else {
					if(this.addRetGenComment.includes(product.id)){
						this.addRetGenComment.splice(this.addRetGenComment.indexOf(product.id),1);
					}
				}
				this.$nextTick(function () {
					this.$store.commit('order/modifyRetGenCommentRequired', {
						'phaseId': this.phase.phase_detail.id,
						'productId': product.id,
						'required': this.addRetGenComment
					});				
				})
			}else{
				if(this.isForecast && event.target.value > (product.allocated - product.forecasted)){
					event.target.value = product.allocated - product.forecasted;
				}
				if(this.notForecast && (event.target.value > (product.forecast_received - product.forecast_ordered))){
					event.target.value = product.forecast_received - product.forecast_ordered;
				}
			}
			this.$nextTick(function () {
				this.$store.commit('order/modifyProductQty', {
					'phaseId': this.phase.phase_detail.id,
					'productId': product.id,
					'qty': event.target.value,
					'type': type
				});				
			})
		},
		modifyAreaProductQty: function(product, event, area){
			if(product.category_id == 4){
				this.modifyProductQty(product, event, area);
				return;
			}
			if(this.isForecast || (this.notForecast && this.form.areaDate[area] != "" && this.areaFileExists(area))){
				this.$nextTick(function () {
					this.$store.commit('order/modifyAreaProductQty', {
						'areaId': area,
						'productId': product.id,
						'qty': event.target.value,
						'areaDate': this.notForecast ? this.form.areaDate[area] : null
					});				
				})
			}else{
				event.target.value = null;
				this.form.areaQty[area+'_'+product.id] = ''
				let err = {
				title: 'First select a deleviery date and upload the client sign-off sheet',
				type: 'error',
				postion: 'top'
				}
				this.$store.commit('setStatus', err)
			}
		},
		modifyProductComment: function(product, event, area,phase,type){
			if(type=='Area')
			{
				this.$nextTick(function () {
					this.$store.commit('order/modifyAreaProductComments', {
						'areaId': area,
						'productId': product.id,
						'comment': event.target.value
					});				
				})
			}
			if(type=='RetGen') {
				this.$nextTick(function () {
					this.$store.commit('order/modifyRetGenProductComments', {
						'phaseId': phase,
						'productId': product.id,
						'comment': event.target.value
					});				
				})
			}
		},
	},
	created: function () {
		if(this.role === 'Reticulation Manager' || this.role === 'Regional Manager' || this.role === 'Site Manager'){
			this.showRetic = true;
		}
		var areas = this.phase.areas
	}
}
</script>

<style lang="css" scoped>
.custom-css {
  background-color: white;
}
</style>
